import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Theme, colors } from '../theme';

const GA_CATEGORY = 'Header Menu';

const MenuList = styled.ul`
  list-style: none;
  margin: 0;
  li {
    color: #333;
    font-size: 14px;
    text-decoration: none;
    padding: 3px 0;
    display: block;
  }
`;

const MenuSection = styled.div`
  border-bottom: 1px solid ${colors.LIGHT_GREY};
`;

export const MenuLink = styled.a`
  font-size: 15px;
  color: #333;
  text-decoration: none;
  color: ${colors.MEDIUM_DARK_GREY};
  padding: 10px 10px 10px 0;
  display: inline-block;
  &:hover,
  &:visited {
    color: #555;
  }

  ${props =>
    props.primary &&
    css`
      color: ${props.theme.primary};
      &:hover,
      &:visited {
        color: ${props.theme.primary};
      }
    `};
`;

const MessagesNumber = styled.span`
  color: ${Theme.snow};
  background-color: ${Theme.danger};
  border-radius: 4px;
  padding: 1px 3px;
  line-height: 1.5;
  margin: 4px 0;
`;

export const MenuContents = ({ siteSource, loginData, mobile }) => (
  <MenuList style={{ padding: mobile ? '0px' : '0 10px' }}>
    {mobile && (
      <MenuSection>
        <li>
          <MenuLink
            href="/"
            title="Home"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Home - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Home
          </MenuLink>
        </li>
      </MenuSection>
    )}

    {mobile && (
      <MenuSection>
        <li>
          <MenuLink
            href="/get_quotes_simple"
            title="Get Quotes"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Get Quotes - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Get Quotes
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="http://hipag.es/1YGeRMs"
            title="Download the App"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Download the App - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Download the App
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/advertise"
            title="List Your Business"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked List Your Business - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            List Your Business
          </MenuLink>
        </li>
      </MenuSection>
    )}

    {mobile && (
      <MenuSection>
        <li>
          <MenuLink
            href="/find"
            title="Directory"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Directory - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Directory
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/articles"
            title="Articles"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Articles - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Articles
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/photos"
            title="Photos"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Browse Photos - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Photos
          </MenuLink>
        </li>
      </MenuSection>
    )}

    {loginData && loginData.logged_in ? (
      <MenuSection>
        <li>
          <MenuLink
            href="/feed"
            title="Your Friends"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - Your Friends`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Your Friends
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/account/?m=job"
            title="My Jobs"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - My Jobs`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            My Jobs
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/message_centre"
            title="Messages"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - Message Centre`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Messages
          </MenuLink>
          {loginData.number_messages > 0 && (
            <MessagesNumber>{loginData.number_messages}</MessagesNumber>
          )}
        </li>
        <li>
          <MenuLink
            href={loginData.inspiration_board_web_path}
            title="Inspiration Boards"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - My Inspiration Boards`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            My Inspiration Boards
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/account/contacts"
            title="My Contacts"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - My Contacts`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            My Contacts
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/account/edit"
            title="Edit Profile"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked User Menu - My Edit Profile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Edit Profile
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/account/?m=dashboard&a=change_password"
            title="Change Password"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked User Menu - Change Password`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Change Password
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/account/subscribe"
            title="Unsubscribe"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Clicked User Menu - Unsubscribe`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Unsubscribe
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/account/?m=public&a=logout"
            title="Logout"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked User Menu - Logout`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Logout
          </MenuLink>
        </li>
      </MenuSection>
    ) : (
      <MenuSection>
        <li>
          <MenuLink
            href="/register"
            title="Register"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Sign Up - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Register
          </MenuLink>
        </li>
        <li>
          <MenuLink
            href="/login"
            title="Sign in"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Login - Mobile`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Sign in
          </MenuLink>
        </li>
      </MenuSection>
    )}
  </MenuList>
);

MenuContents.propTypes = {
  user_role: PropTypes.string,
  inspiration_board_web_path: PropTypes.string,
  siteSource: PropTypes.string,
  loginData: PropTypes.object,
  mobile: PropTypes.bool
};

export default MenuContents;
